import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery, useQueryClient } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const PRODUCT_CARDS_QUERY = gql`
  query ProductCardsV2($filter: ProductCardsV2Filter!) {
    productCardsV2(filter: $filter) {
      cards {
        uuid
        titleKey
        descriptionKey
        rank
        imagePath
        categoryUuids
        serviceCode
        primaryPath
        primaryExternal
        partnerImagePath
      }
      categories {
        uuid
        titleKey
        rank
        isActive
      }
    }
  }
`;

export function useProductCards(categorySlug) {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, error, loading, refetch } = useQuery(PRODUCT_CARDS_QUERY, {
    noThrow: true,
    variables: {
      filter: {
        businessEntityUuid,
        ...(categorySlug && { categorySlug }),
      },
    },
  });

  useError(error);

  return {
    data: data?.productCardsV2 || { cards: [], categories: [] },
    error,
    loading,
    refetch,
  };
}

export function useProductCardsCache(categorySlug) {
  const client = useQueryClient();
  const { businessEntityUuid } = useBusinessEntity();

  const query = PRODUCT_CARDS_QUERY;
  const variables = {
    filter: {
      businessEntityUuid,
      ...(categorySlug && { categorySlug }),
    },
  };

  const cachedEntry = client.cache.readQuery({
    query,
    variables,
    operationName: 'ProductCardsV2',
  });

  return cachedEntry?.data?.productCardsV2 ?? null;
}
